function numberToOrdinalBulgarian(number: number) {
  const words = [
    'Нулев',
    'Първи',
    'Втори',
    'Трети',
    'Четвърти',
    'Пети',
    'Шести',
    'Седми',
    'Осми',
    'Девети',
    'Десети',
    'Единадесети',
    'Дванадесети',
    'Тринадесети',
    'Четиринадесети',
    'Петнадесети',
    'Шестнадесети',
    'Седемнадесети',
    'Осемнадесети',
    'Деветнадесети',
  ];

  if (number >= 0 && number <= 19) {
    return words[number];
  } else {
    const lastDigit = number % 10;
    const tens = Math.floor((number % 100) / 10);

    let ordinal = '';

    if (tens > 1) {
      ordinal += words[tens] + 'надесети';
      if (lastDigit > 0) {
        ordinal += ' и ' + words[lastDigit];
      }
    } else {
      ordinal += words[lastDigit];
    }

    return ordinal;
  }
}

export default numberToOrdinalBulgarian;